import React, { useState, useMemo } from 'react'
import { Typography, IconButton, TableCell, Box, useTheme } from '@mui/material'
import { HiOutlineArrowDown, HiOutlineArrowUp } from 'react-icons/hi'
import { IconContext } from 'react-icons'

const MyTableCellHeader = ({ header, sort, sortedColumn, sortedColumnMode, resize = true }) => {
  const theme = useTheme()
  const [width, setWidth] = useState(150)

  const comparisonKey = header ? header.name : 'none'
  const headerLabel = header ? header.label || header.name : 'Erreur Colonne'

  const isExpandColumn = header && header.isExpand === true
  const isSortable = sort && header.isSorting !== false && !isExpandColumn

  const currentSortingState = useMemo(() => {
    return isSortable && sortedColumn === comparisonKey ? sortedColumnMode : 0
  }, [sortedColumn, sortedColumnMode, comparisonKey, isSortable])

  const handleClick = () => {
    if (!isSortable) return

    let newState

    if (sortedColumnMode === 0) {
      newState = 1 // OFF -> ASC
    } else if (sortedColumnMode === 1) {
      newState = 2 // ASC -> DESC
    } else {
      newState = 0 // DESC -> OFF
    }

    if (sort) sort(header, newState)
  }

  const handleMouseDown = (e) => {
    if (!resize || isExpandColumn) return
    e.preventDefault()
    let startX = e.clientX

    const handleMouseMove = (e) => {
      const endX = e.clientX
      const deltaX = endX - startX
      if (deltaX !== 0) {
        setWidth((prev) => Math.max(prev + deltaX, 50))
        startX = endX
      }
    }

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  }

  const headerStyle = {
    height: '30px',
    padding: '10px',
    width: isExpandColumn ? '40px' : width,
    position: 'sticky',
    cursor: isSortable ? 'pointer' : 'default',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  }

  const resizeStyle = {
    background: 'transparent',
    cursor: 'col-resize',
    position: 'absolute',
    right: 0,
    borderRight: '3px solid rgba(255, 255, 255, 0.5)',
    height: '60%',
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: '50px',
    marginRight: '5px',
    userSelect: 'none'
  }

  return (
    <TableCell
      style={headerStyle}
      onClick={isSortable ? handleClick : undefined}
      padding={isExpandColumn ? 'checkbox' : 'normal'}
    >
      {!isExpandColumn ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            sx={{
              fontWeight: 600,
              flexGrow: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: theme.palette.common.white
            }}
            noWrap
          >
            {headerLabel}
          </Typography>

          {isSortable && (
            <IconButton size='small' onClick={handleClick} disableRipple style={{ backgroundColor: 'transparent' }}>
              <IconContext.Provider
                value={{ color: currentSortingState !== 0 ? theme.palette.common.white : 'rgba(255, 255, 255, 0.5)' }}
              >
                {currentSortingState === 2 ? (
                  <HiOutlineArrowDown />
                ) : currentSortingState === 1 ? (
                  <HiOutlineArrowUp />
                ) : (
                  <HiOutlineArrowDown />
                )}
              </IconContext.Provider>
            </IconButton>
          )}

          {resize && !isExpandColumn && <div style={resizeStyle} onMouseDown={handleMouseDown} />}
        </Box>
      ) : (
        <Box sx={{ height: '100%', width: '100%' }} />
      )}
    </TableCell>
  )
}

export default MyTableCellHeader
